import React, { useRef, useState , useEffect } from 'react'
import { emailExistsApi, parentUserCreationApi } from '../../../../services/parent-register-api';
import { assetPath, getCookie, validateEmail, validatePassword, getItemFromSessionStorage, setLandingPageUrl, setCookieWithAge } from '../../../../utils/web-helper';
import ShowPasswordIcon from '~images/parent-signup/show-password.svg';
import { trackToGtmFE } from '../../../../utils/gtm-event-common';
import * as S from './style';
import TurnstileParentRegistration from '../../../turnstile/turnstile-parent-registration';
import { useTurnstile } from '../../../turnstile/context/TurnstileContext';
import { CLIENT_ERRORS } from '../client-errors';


const ParentSignupForm = ({isEmailPreference, isPrivacyPolicyAccepted, setSignupError, setHideToast, 
  setShowSuspectedPopup, email, setEmail, password, setPassword, setSuspectedFormData
}) => {
  const { handleTurnstileSubmit, clearPollTimeout, displayTurnstileSpinner, turnstileSpinnerActive } = useTurnstile();
  const [showPasswordHelperText, setShowPasswordHelperText] = useState(true)
  const [error, setError] = useState({
    emailError: '',
    passwordError: '',
  });
  const emailChangeHandler = (value) => {
    setEmail(value);
    setCookieWithAge('user_email',value);
    setError({ ...error, emailError: ""})
  }

  const passwordChangeHandler = (value) => {
    setPassword(value);
    setError({ ...error, passwordError: ""})
    setShowPasswordHelperText(value.length < 6 || false)
  }

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact_me_by_fax_only: "", // Honeypot field
  });

  const emailBlurHandler = async (value) => {
    let validateEmailResp = validateEmail(value)
    if(validateEmailResp.validated){
      emailExistsApi({email: value})
        .then((res) =>{
          if(res.response)
            setError({ ...error, emailError: "Email Exist"})
        })
    }else{
      setError({ ...error, emailError: "Please enter a valid email."})
    }
  }

  useEffect(() => {
    setLandingPageUrl();
    // Hide the honeypot field using JavaScript (in case CSS is ignored)
    document.getElementById("contact_me_by_fax_only").style.display = "none";
  }, []);

  useEffect(() => {
    return () => {
      clearPollTimeout();
    }
  }, []);

  const passwordBlurHandler = (value) => {
    let validatePasswordResp = validatePassword(value)
    if(validatePasswordResp.validated){
      setError({ ...error, passwordError: '' });
    }else{
      setError({ ...error, passwordError: validatePasswordResp.error || "Please try again" });
    }
  }

  const userCreation = (turnstileSecurityToken) =>{
    try{
      let time_zone = getCookie("timezone")
      
      parentUserCreationApi({
        user: {
          type: "parent",
          email,
          password,
          signupFlow:"",
          time_zone,
          dob_day: "",
          dob_month: "",
          tnc_privacy: isPrivacyPolicyAccepted,
          email_preference: isEmailPreference,
          landing_page_url: getItemFromSessionStorage('landing_page_url') || JSON.stringify(window.location.pathname),
          ad_group_id: getItemFromSessionStorage('ad_group_id')?.[0] || 'NA',
          is_bot_detected: formData.contact_me_by_fax_only? true : '',
          ...(turnstileSecurityToken && {"cf-turnstile-response": turnstileSecurityToken})
        },
        turnstile_enabled: true
      })
      .then(() =>{
        typeof trackEventOnGA != "undefined" && trackEventOnGA('Initiated Sign up with', 'email','parent');
        displayTurnstileSpinner(false);
        // [AI GENERATED CODE]
        // Set pending source before navigation so createSession picks up correct userId on /parent-dashboard.
        if (typeof window.MUS !== 'undefined') window.MUS.setPendingSource('parent_signup');
        window.location.href = '/parent-dashboard';
      })
      .catch(e => {
        console.log(e)
        setError({ ...error, emailError: "Something went wrong"})
        displayTurnstileSpinner(false);
      })
    }catch(error){
      setError({ ...error, emailError: "Email Exist"})
      displayTurnstileSpinner(false);
    }
  }

  const checkSuspectedSignup = () => {
    const notSupspectedEmail  = ["gmail", "live", "yahoo", "ymail", "outlook", "msn", "aol", "rediff", "icloud", "comcast", "hotmail"];
    // Create a regular expression pattern with the provided words separated by |
    var regexPattern = new RegExp(notSupspectedEmail.join('|'), 'i');
    
    // Test if the email matches the regular expression
    return !regexPattern.test(email);
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    trackToGtmFE('clicked_parent_signup_cta',{'Click Text': 'Create Account'});
    localStorage.setItem('parent_signup_method', 'email');
    if( error.emailError === "" &&  error.passwordError === ""){
      if(window.isEuropeIP === "true" && !isPrivacyPolicyAccepted){
        setSignupError("You must agree to our terms & conditions for creating the account.");
        setHideToast(false);
      }
      else{
        const turnstileResponse = await handleTurnstileSubmit(checkSuspectedSignup);

        if (turnstileResponse.failure) {
          setSignupError(CLIENT_ERRORS.refreshPageError);
          setHideToast(false);
          return;
        }

        if (checkSuspectedSignup()) {
          setSuspectedFormData(formData);
          setShowSuspectedPopup(true);
          return;
        }

        userCreation(turnstileResponse.token);
      }
    }
  }

  return(
    <S.ParentSignupForm onSubmit={submitHandler}>
      {/* Honeypot Field (hidden from users) */}
      <div style={{ display: "none" }}>
        <input
          type="text"
          name="contact_me_by_fax_only"
          id="contact_me_by_fax_only"
          value={formData.contact_me_by_fax_only}
          onChange={handleChange}
        />
      </div>
      <FormTextInput isRequired={true} type="email" label={"Parent Email"} placeholder={"Parent Email"} autocomplete="home email" name="email" onChangeHandler={emailChangeHandler} onBlurHandler={emailBlurHandler} errorMsg={error.emailError} email={email}/>
      <FormTextInput isRequired={true} type="password" label={"Password"} placeholder={"Set Password ( 6+ characters )"} autocomplete="current-password" name="password" helperText={"Password must be at least 6 characters"} onChangeHandler={passwordChangeHandler} onBlurHandler={passwordBlurHandler} errorMsg={error.passwordError} showHelperText={showPasswordHelperText}/>
      {<TurnstileParentRegistration />}
      <S.FormSubmitWrapper showProgressSpinner={turnstileSpinnerActive()}>
        <S.FormSubmit value={"Create Account"} disabled={turnstileSpinnerActive()} type="submit" data-testid="create-account"/>
      </S.FormSubmitWrapper>
    </S.ParentSignupForm>
  )
}

const FormTextInput = ({
  name,
  isRequired,
  type,
  label,
  placeholder,
  autocomplete,
  helperText,
  errorMsg,
  showHelperText,
  onChangeHandler,
  onBlurHandler, 
  email
}) => {
  const [ showLabel, setShowLabel ] = useState(false)
  const [ showPassword, setShowPassword ] = useState(false)
  const input = useRef()

  const viewLabel = (show) => {
    if(!input.current.value.length || show)
      setShowLabel(show)
  }

  const blurHandler = (value) => {
    viewLabel(false)
    onBlurHandler(value)
  }

  const setEmailInLS = () => {
    localStorage.setItem("email-entered", input.current.value);
  }

  return(
    <S.InputWrap>
      <S.Label showLabel={showLabel}>{label}</S.Label>
      <S.InputGroup>
        <S.TextInput
          ref={input}
          required={isRequired}
          type={showPassword? "text" : type}
          placeholder={showLabel?"":placeholder}
          autocomplete={autocomplete}
          showLabel={showLabel}
          onFocus={()=>viewLabel(true)}
          onBlur={(e)=>blurHandler(e.target.value)}
          onChange={(e)=>onChangeHandler(e.target.value)}
          data-testid={"input_"+name}/>
        {type==="password" && <S.ShowPasswordEye src={assetPath(ShowPasswordIcon)} onClick={()=>setShowPassword(prev => !prev)} data-testid="show-password"/>}
        {helperText && showHelperText && !errorMsg && showLabel && <S.HelperText data-testid={"signup_"+name+"helper_text"}>{helperText}</S.HelperText>}
        {errorMsg === "Email Exist"?
          <S.ErrorMessage data-testid={"signup_"+name+"_error"}>User with this email already exists. <a href="/signin?userType=parent#/parent" onClick={() => setEmailInLS()}>Click here to login</a>.</S.ErrorMessage>
          :errorMsg&&<S.ErrorMessage data-testid={"signup_"+name+"_error"}>{errorMsg}</S.ErrorMessage>}
      </S.InputGroup>
    </S.InputWrap>
  )
}

export default ParentSignupForm;